<template>
  <div>
    <nos-loading ref="nppfs-loading" />
    <div class="nppfs-keypad-div" style="position:relative;">
      <component
        v-for="item in components"
        :is="item.component"
        :key="item.id"
        :ref="item.ref"
        v-bind="item.props"
        v-on="item.events"
        @update="update"
      ></component>
    </div>
  </div>
</template>

<script>
import NOSLoading from "./NOSLoading";

export default {
  components: {
    // "nos-input" : nosInput
    "nos-loading": NOSLoading,
  },
  props: {
    component: {
      // type: Object,
      required: true,
    },
  },
  computed: {
    components() {
      return this.component;
    },
  },
  data() {
    return {
      text: "",
      password: "",
      otp: "",
      pwd: "",
      modfiAfPwd:"",
      modfiBfPwd:"",
      pwdCnfrm: "",
      id: "",
      brncoEcrypPwd: "",
      custRelatdNo:"",
      inquryBrncoEcrypPwd:"" //계좌비밀번호
    };
  },
  mounted() {},
  methods: {
    update(e) {
      this.id = e.id;
      this[e.id] = e.textValue;
    },
  },
};
</script>